import { useEffect } from 'react';
import { useEnvironment } from '../../context/Environment/EnvironmentContext';
import Environment from '../../constants/Environment';

const NrProvider = ({ children }: { children: JSX.Element }): JSX.Element => {
  const { ENVIRONMENT_NAME } = useEnvironment();
  function setupNewRelic(): void {
    const event = document.createEvent('Event');

    event.initEvent('DOMContentLoaded', true, true);
    document.dispatchEvent(event);

    event.initEvent('onreadystatechange', true, true);
    document.dispatchEvent(event);

    event.initEvent('load', true, true);
    window.dispatchEvent(event);

    event.initEvent('onload', true, true);
    window.dispatchEvent(event);
  }
  useEffect(() => {
    if (
      ENVIRONMENT_NAME !== Environment.LOCAL &&
      ENVIRONMENT_NAME !== Environment.TEST &&
      !document.getElementById('new-relic-spa-agent')
    ) {
      const scriptEl = document.createElement('script');
      scriptEl.type = 'text/javascript';
      scriptEl.id = 'new-relic-spa-agent';
      scriptEl.src = `/account/newrelic/${ENVIRONMENT_NAME}.js`;
      scriptEl.async = true;
      document.head.appendChild(scriptEl);
      setTimeout(setupNewRelic, 1000);
    }
  }, [ENVIRONMENT_NAME]);

  return children;
};

export default NrProvider;
